module.exports = __webpack_public_path__ + "img/dz.9a498456.svg";